<template>
  <div class="translation-toggle">
    <div v-show="!showTranslation" class="translation-original">
      <slot></slot>
    </div>

    <div v-show="showTranslation" class="translation-translated" v-html="sanitizedHtml">
    </div>

    <button
        @click="toggle"
        :disabled="isLoading"
        class="btn tag-primary mt-8"
        style="font-size: 12px; padding: 2px 12px;"
    >
      <span v-if="isLoading">⏳</span>
      <span v-else-if="showTranslation">🇷🇺 Орысша</span>
      <span v-else>🇰🇿 Қазақша</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import DOMPurify from 'dompurify';

const props = defineProps<{
  uid: string;
  entityType: string;
}>();

const showTranslation = ref(false);
const translatedText = ref('');
const isLoading = ref(false);

// Очищаем и заменяем \n на <br>
const sanitizedHtml = computed(() => {
  if (!translatedText.value) return '';

  // Сначала заменяем переносы на <br>
  const withBreaks = translatedText.value.replace(/\n/g, '<br>');

  // Потом очищаем от XSS
  return DOMPurify.sanitize(withBreaks, {
    ALLOWED_TAGS: ['br'], // Разрешаем только <br>
    ALLOWED_ATTR: [],     // Запрещаем все атрибуты
  });
});

async function toggle() {
  if (showTranslation.value) {
    showTranslation.value = false;
    return;
  }

  if (translatedText.value) {
    showTranslation.value = true;
    return;
  }

  isLoading.value = true;
  try {
    const payload = {
      uid: props.uid,
      entityType: props.entityType,
      language: 'ru-kk',
    };

    const response = await fetch('/api/v1/translate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Translation failed');
    }

    const data = await response.json();
    translatedText.value = data.translatedText;
    showTranslation.value = true;
  } catch (error) {
    console.error('Translation error:', error);
    translatedText.value = '❌ Ошибка перевода';
    showTranslation.value = true;
  } finally {
    isLoading.value = false;
  }
}
</script>

<style scoped>
.translation-toggle {
  display: block;
  width: 100%;
}

.translation-original,
.translation-translated {
  display: block;
  width: 100%;
  margin-bottom: 8px;
}
</style>